/**
 * @module views\sys\source\editCode
 */
import Vue from "vue";
import Component from "vue-class-component";
import GhBase from "@/components/ghBase";
import { Prop, Watch } from "vue-property-decorator";

@Component
export default class EditCode extends GhBase {
  private model: IndexObject | any = null;
  protected title = "代码编辑";

  private codeOptions = {
    readOnly: false,
    language: "python",
    autoIndent: true,
    automaticLayout: true
  };

  private code = "";

  protected onNavigateTo(params) {
    this.model = params;
    if (this.model) {
      this.codeOptions.language=this.model.Language;
      // this.codeOptions={...this.codeOptions,language:this.model.Language};
      if (this.model.Code) {
        this.code = this.model.Code;
        return;
      }
    }
    this.code = "";
  }

  activated() {}
  private cancel() {
    this.navigate("/sys/source/source");
  }

  private submit() {
    this.model.Code = this.code;
    this.navigate("/sys/source/source", this.model);
  }
}
